module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Evangelism can be defined as spreading the gospel through personal witness and passionate advocacy. To be an effective evangelist, you must be passionately committed to your cause. But even unbridled passion is not enough. Being effective in anything, but especially communications and PR, requires creativity, credibility, responsiveness, and relentlessness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a twenty-four-hour news cycle with multiple issues competing for attention, it is imperative to understand how to break through in the media. It’s not enough to build a vital, noteworthy campaign. If reporters don’t find you "), _c('em', [_vm._v("credible")]), _vm._v(" (meaning they don’t trust that you are an expert in your field or providing accurate information), if you aren’t finding "), _c('em', [_vm._v("creative")]), _vm._v(" ways to garner attention, if you aren’t "), _c('em', [_vm._v("responsiv")]), _vm._v("e when the media reaches out or "), _c('em', [_vm._v("relentless")]), _vm._v(" when they don’t, you’re likely to experience minimal success.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Being Credible")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("You could have a public relations budget the size of Disney World, yet without credibility, members of the press will not ")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("take you seriously. What’s more, once a PR professional or a spokesperson develops a reputation of lacking credibility, reporters may discount them as a source for future stories. It can make your organization a laughingstock in media newsrooms.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people don’t set out to lack credibility. It happens when you, wittingly or not, provide inaccurate information that can damage your or a reporter’s reputation. Imagine providing the wrong data to a journalist who includes it in her story. The journalists and the media outlet that employs them now run the risk of being forced to run a costly and embarrassing correction. Now, we’re talking not only about damage to a reporter’s reputation but also to their employer’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another way spokespeople get labeled untrustworthy is by being afraid to admit they don’t know an answer when asked a question. Pretending to know the answer to a question is a surefire way to be labeled unreliable, and no amount of money in the world can solve credibility issues.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Being Creative")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("Money also doesn’t correlate to creativity, which is the cornerstone of a winning pitch and sustained media attention. A pitch is a short paragraph or pithy statement explaining your issue and why it merits coverage or media interest. In media terms, creativity is about developing an unusual and appealing way to present information. It could be sharing information in the form of an infographic rather than a press release. It could be developing unusual props for a press conference. ")]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("The bottom line is that outside-the-box thinking is especially important when you work for a cash-strapped entity.")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Reporters receive hundreds of press releases from competing interests, so thinking through creative and visually appealing ways to share information is key. If you’re a one-person communications shop, you can network with other communicators from other organizations to get ideas for how to present information in unusual ways.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Being Responsive")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By "), _c('em', [_vm._v("responsive")]), _vm._v(", I mean replying to media inquiries in a timely fashion and using the initial contact as an opportunity to build a long-term relationship with a reporter. Responsiveness is about following through on promises to the media as well as to allies. It also means being prepared to jump on current events to tell a story you’ve been sitting on for months or longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even if you’re pressed for time and unable to provide a detailed response, a simple acknowledgment of a message shows a level of responsiveness that is appreciated by those working on tight deadlines. In fact, of all the work on my plate, I view media inquiries as one of the most important aspects of my job. That means I’ll drop everything to research reporters (and their media outlets) who have contacted me for a story so I can respond effectively. I even make it a point to check my email a couple of times throughout the weekend so I can respond to after-hour inquiries as quickly as possible.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('strong', [_vm._v("Being Relentless")])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To be relentless you must believe in something bigger than yourself. If you believe in something bigger than yourself, you’ll go to the ends of the earth fighting for it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Relentlessness is important in communications because public relations professionals are often bombarded with the word “no.” It takes time and many rejections before successfully placing a news story. If you become discouraged after a reporter ignores or is disinterested in your pitch, you may be unwilling to pitch to other reporters. If this happens, you’re likely to get minimal coverage. If you become discouraged when you don’t get a timely response to a pitch and consequently fail to follow up, you might be missing an opportunity to engage a reporter who may simply be busy, rather than permanently uninterested in your story. Relentlessness is not shutting down at the first or second “no.” It’s also about refusing to believe a “no” today is a “no” tomorrow. Just because a reporter can’t cover one story doesn’t mean he or she will be unwilling to cover future stories. Moreover, a lack of an immediate response from a reporter could mean the reporter missed your email, and you may need to follow up. Maintaining enthusiasm in the face of “no” or in the face of silence is critical in this line of work.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("How to Use This Book")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("While I’ve worked for organizations (such as SEIU and SEIU District 1199) who had paid media budgets, those budgets paled in comparison to those of corporations. I offer this ")]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("information in the spirit of full disclosure, as even a modest paid media budget is more than what many of the people who read this book may enjoy.")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Certainly, if you’re working for a candidate for political office in an era of outsized money in politics and you’re thinking about how to get your message out in the face of stiff opposition, you need significant funds. Imagine a presidential election in which one candidate had funds to advertise on television and the other did not; the person without the funds would surely lose. However, it’s a little different if you work for a social impact entity. In this case, you do not need a multimillion-dollar communications budget (although I will not begrudge you if you have one) to elevate your organization’s critical work. Your issues aren’t less important because your budget is small. And regardless of your resources, the four principles to highlighting their importance remain the same: being relentless, responsive, credible, and creative. In drawing from my personal experience on a number of social justice campaigns, I provide a road map for using the four principles to successfully promote your issues—even on a cash-strapped budget.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("In ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(", I make the case for communications. When money is tight, spending it on communications can often seem superfluous. It is not. I explain why.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 2")]), _vm._v(" through "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(", I dive deeply into each of the four principles. I use real-life examples to illustrate their power and provide concrete tips on how to leverage them to get the most bang for your buck. I also offer valuable no-cost tips for increasing your communication impact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" is an exploration of how being credible, creative, responsive, and relentless apply to the growing and increasingly important area of social media PR.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" is full of hands-on budget-friendly PR tactics built on the foundation of the four principles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" provides specific advice to communications professionals on how the four principles should come to the forefront when managing a crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And last, I conclude with tips I learned along the way about how to press on in the midst of fear, burnout, failure, and doubt. The communications field can be very stressful yet rewarding. By applying the four principles I discuss in the book, maintaining a mind-set of reflection and growth, and finding aspects of your job that feed your spirit, you will undoubtedly find success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My goal in writing this book is to provide a sound foundation for communications professionals who are struggling to make an impact on a limited organizational budget. My hope is that this book provides you not only with helpful tools to promote your issues in a cost-effective way but also with proof that if you stay on the track of being credible, creative, responsive, and relentless, you will have success. I did, and I hope my stories give you the resolve to keep on passionately evangelizing for worthy causes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 75
// module chunks = 0